export default __webpack_public_path__ + "static/media/303.7902ca39.png";